import { render, staticRenderFns } from "./index.vue?vue&type=template&id=401cefff&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=401cefff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cefff",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BuyPainting: require('/web/components/buy/BuyPainting.vue').default,CustomSwiper: require('/web/components/CustomSwiper.vue').default,AmpCustomSwiper: require('/web/components/amp/AmpCustomSwiper.vue').default})
